import { format, parseISO } from "date-fns";

/** Date shown on each stock entry; a receipt can lack a link to an otherwise recorded sowing. */
export function StockSowingDate({ value, source }: { value?: string | null; source?: string | null }) {
  if (value) return <>{format(parseISO(value), "dd MMM yyyy")}</>;
  if (source === "Agroforestry") {
    return <span title="This stock entry has no linked sowing date">No linked sowing</span>;
  }
  return <>—</>;
}
